module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "P_Heading_1__And__Page_Break",
    attrs: {
      "id": "auto_bookmark_toc_1"
    }
  }, [_c('span', [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }), _vm._v(" "), _c('p', {
    staticClass: "P_Normal__And__Left_Indent"
  }, [_c('span', {
    staticStyle: {
      "font-size": "1.17em"
    }
  }, [_vm._v("SEEING THIS")]), _vm._v(" published is like a dream come true, one that would not have been possible without a lot of people. I can’t name you all, but know that your support and your comments were much appreciated and that you gave me the strength to keep going and improving.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("But I want to thank the people who stood by me from beginning to end. Naomi, who told me I could write this story, and believed in me from the start. This book wouldn’t exist if it weren’t for you. Annie, who gave me a chance and held my hand along the way, I can never thank you enough. Eli, who lent me her name along with her time to give me feedback I will always treasure. Your friendship is a gift. Rain, whose teacher’s pen helped me improve the quality of this novella. I look forward to hugging you again.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("I would also like to thank Dreamspinner Press for giving me a chance. Their Art Department has made great work with my cover, even if I’m sure Brooke Albrecht wanted to kill me along the way. The cover turned out perfect in my eyes; thank you, Brooke! And I can’t forget my editors; they were the ones who made the book better and made it look as if I know how to use commas and prepositions. I would have been lost without you.")]), _vm._v(" "), _c('p', {
    staticClass: "P_Normal"
  }, [_vm._v("And last but not least, I want to thank everyone who huddled under the duvet with me when I felt like hiding. You were the best company a writer could ask for.")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34cb2de7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/section0004.vue
// module id = 66
// module chunks = 0